module.exports = __webpack_public_path__ + "img/nancomcy-agence-communication-nancy-site-internet.62750bc.jpeg";